function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import defaultConfig from './defaultConfig';
import Translator from './Translator';
import Engine from './Engine';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import RPT from 'prop-types';
var Provider = /*#__PURE__*/
function (_Component) {
  _inherits(Provider, _Component);
  function Provider() {
    _classCallCheck(this, Provider);
    return _possibleConstructorReturn(this, _getPrototypeOf(Provider).apply(this, arguments));
  }
  _createClass(Provider, [{
    key: "getConfig",
    value: function getConfig() {
      return _objectSpread({}, defaultConfig, this.props.config || {});
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        pathname = _this$props.pathname;
      var dispatch = this.context.store.dispatch;
      var config = this.getConfig();
      var ConnectedTranslateContextProvider = connect(function (state) {
        return {
          messages: state[config.reduxRoot].get('messages')
        };
      })(TranslateContextProvider);
      this.engine = this.engine || new Engine(config, dispatch, pathname);
      return React.createElement(ConnectedTranslateContextProvider, {
        config: config,
        engine: this.engine,
        pathname: pathname
      }, children);
    }
  }]);
  return Provider;
}(Component);
_defineProperty(Provider, "propTypes", {
  children: RPT.object.isRequired,
  config: RPT.object,
  pathname: RPT.any
});
_defineProperty(Provider, "contextTypes", {
  store: RPT.object
});
export { Provider as default };
var TranslateContextProvider = /*#__PURE__*/
function (_Component2) {
  _inherits(TranslateContextProvider, _Component2);
  function TranslateContextProvider() {
    _classCallCheck(this, TranslateContextProvider);
    return _possibleConstructorReturn(this, _getPrototypeOf(TranslateContextProvider).apply(this, arguments));
  }
  _createClass(TranslateContextProvider, [{
    key: "getChildContext",
    // eslint-disable-line react/no-multi-comp
    value: function getChildContext() {
      var _this$props2 = this.props,
        config = _this$props2.config,
        engine = _this$props2.engine;
      this.translator = this.translator || new Translator(this.context.store.getState, config, engine);
      return {
        translate: this.translator
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props3 = this.props,
        engine = _this$props3.engine,
        pathname = _this$props3.pathname;
      if (engine) engine.updateLocation(pathname);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return TranslateContextProvider;
}(Component);
_defineProperty(TranslateContextProvider, "propTypes", {
  children: RPT.object.isRequired,
  config: RPT.object,
  engine: RPT.object,
  pathname: RPT.any
});
_defineProperty(TranslateContextProvider, "defaultProps", {
  config: {}
});
_defineProperty(TranslateContextProvider, "contextTypes", {
  store: RPT.object
});
_defineProperty(TranslateContextProvider, "childContextTypes", {
  translate: RPT.object
});